module.exports = __webpack_public_path__ + "static/media/display-1.73b6f469.png";